<mat-form-field
  [appearance]="appearance"
  [ngClass]="{ 'without-padding': withoutPadding }"
  (click)="onMenuOpened()"
  class="flex-auto w-full"
  [matMenuTriggerFor]="isDisabled ? null : menu"
  #trigger="matMenuTrigger"
>
  <mat-label>{{ label }}</mat-label>

  <!-- Affichage historique (défaut) : texte « nom » ou « N sélectionné(s) » -->
  <input
    *ngIf="!chipsInField"
    class="flex-auto w-full"
    type="text"
    matInput
    readonly
    [required]="isRequired()"
    [disabled]="isDisabled"
    [value]="getSelectedItemsText()"
  />

  <!-- Opt-in chipsInField : sélection en chips dans le champ, wrap naturel du mat-chip-list -->
  <mat-chip-list #chipList *ngIf="chipsInField" class="chips-in-field">
    <mat-chip
      *ngFor="let item of selectedItemsForChips()"
      [removable]="!isDisabled"
      (removed)="updateSelectedItems(item, false)"
    >
      {{ displayFn ? displayFn(item) : item[displayProperty] }}
      <mat-icon matChipRemove *ngIf="!isDisabled" (click)="$event.stopPropagation()">cancel</mat-icon>
    </mat-chip>
    <input
      class="chips-in-field-input"
      type="text"
      matInput
      readonly
      [required]="isRequired()"
      [disabled]="isDisabled"
      [matChipInputFor]="chipList"
      [placeholder]="selectedItemsForChips().length ? '' : placeholder || ''"
    />
  </mat-chip-list>

  <button
    *ngIf="hasSelectedItems() && !isDisabled"
    class="text-secondary clear-selection-btn"
    mat-icon-button
    matSuffix
    type="button"
    (click)="clearAllSelections($event)"
  >
    <mat-icon>close</mat-icon>
  </button>

  <mat-icon *ngIf="!hasSelectedItems()" matSuffix>expand_more</mat-icon>

  <mat-menu #menu="matMenu" class="custom-width-menu" (menuOpened)="onMenuOpened()">
    <div class="flex-auto w-full select-all-search-container p-4" [style.width.px]="menuWidth">
      <mat-checkbox
        class="pl-2 pr-3"
        [checked]="selectAllChecked"
        [indeterminate]="hasSelectedItems() && !selectAllChecked"
        (change)="toggleSelectAll($event.checked)"
        (click)="$event.stopPropagation()"
      ></mat-checkbox>

      <div class="search-container">
        <mat-icon>search</mat-icon>
        <input
          #searchInput
          class="flex-auto w-full bg-transparent search-input"
          placeholder="Rechercher..."
          [formControl]="searchControl"
          (click)="$event.stopPropagation()"
        />
        <button
          *ngIf="searchControl.value"
          matSuffix
          mat-icon-button
          aria-label="EFFACER"
          (click)="$event.stopPropagation(); clearSearch()"
        >
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>

    <div class="scrollable-options">
      <div *ngIf="isLoading" class="loading-spinner">
        <mat-spinner diameter="30"></mat-spinner>
      </div>

      <cdk-virtual-scroll-viewport
        *ngIf="!isLoading && filteredItems.length > 0"
        itemSize="20"
        (scrolledIndexChange)="onScrollLine($event)"
        class="scrollable-options"
      >
        <div
          class="option-item clickable-item cursor-pointer"
          *cdkVirtualFor="let item of filteredItems"
          (click)="toggleSelection(item, $event)"
        >
          <mat-checkbox [checked]="item.selected" style="pointer-events: none">
            <div class="py-1 pl-2 w-full">
              {{ displayFn ? displayFn(item) : item[displayProperty] }}
            </div>
          </mat-checkbox>
        </div>
      </cdk-virtual-scroll-viewport>

      <p *ngIf="!isLoading && !hasData">Aucun élément à afficher.</p>
    </div>
  </mat-menu>

  <base-form-input-errors
    [control]="formGroup.controls[controlName]"
    [controlName]="controlName"
    [errorMessages]="defaultErrorMessage"
    [invalidPatternMessage]="invalidPatternMessage"
    [customErrorMessage]="customErrorMessage"
  ></base-form-input-errors>
</mat-form-field>
